import ResetPasswordPage from "./reset-password";
export default ResetPasswordPage;
